export function waitForElem(selector: string) {
  /* Promise-based way to wait for DOM-element
   * to exist. When it does, run a callback. */
  return new Promise(res => {
    if (document.querySelector(selector)) {
      return res(document.querySelectorAll(selector));
    }

    const observer = new MutationObserver(() => {
      if (document.querySelector(selector)) {
        res(document.querySelectorAll(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
}
